import React, { useState } from "react";
import styled from "styled-components";

import HeroProfesorCard from "./HeroProfesorCard";
import GruposProfesorCard from "./GruposProfesorCard";
import ModalCrearGrupo from "./ModalCrearGrupo";

const Container = styled.div`
    display:flex;
    flex-direction:column;
    gap:24px;
    padding:24px clamp(20px,4vw,40px) 40px;
    max-width:1600px;
    margin:0 auto;
    box-sizing:border-box;
`;

export default function DashboardProfesor({
    usuario,
    grupos = [],
    onCrearGrupo,
    onVerGrupos,
    perfilActivo,
    onCambiarPerfil
}) {
    const [mostrarModal, setMostrarModal] = useState(false);

    return (
        <Container>
            <HeroProfesorCard
                usuario={usuario}
                cantidadGrupos={grupos.length}
                perfilActivo={perfilActivo}
                onCambiarPerfil={onCambiarPerfil}
            />

            <GruposProfesorCard
                grupos={grupos}
                onCrearGrupo={() => setMostrarModal(true)}
                onVerGrupos={onVerGrupos}
            />

            <ModalCrearGrupo
                abierto={mostrarModal}
                onCerrar={() => setMostrarModal(false)}
                onGuardar={async (datos) => {
                    // Si falla, el modal muestra el error y sigue abierto
                    await onCrearGrupo(datos);
                    setMostrarModal(false);
                }}
            />
        </Container>
    );
}